import { render, staticRenderFns } from "./CustomWindow.vue?vue&type=template&id=15041f0c&scoped=true&"
import script from "./CustomWindow.vue?vue&type=script&lang=js&"
export * from "./CustomWindow.vue?vue&type=script&lang=js&"
import style0 from "./CustomWindow.vue?vue&type=style&index=0&id=15041f0c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15041f0c",
  null
  
)

export default component.exports